import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Primero los estilos globales: tokens, reset, primitivas (.btn, .icon-btn, .chip, .hit…). El CSS de cada
// componente se importa desde su .tsx, o sea DESPUÉS, y así le gana a una primitiva con la misma
// especificidad (`.card-flag-toggle { position: absolute }` contra `.icon-btn { position: relative }`,
// `--btn-*` puestas en una clase extra). Con el orden al revés `buttons.css` cargaba último y pisaba a
// todo lo eager.
import './styles/index.css';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
